<template>
  <span @click="$emit('click')" class="pointer">
    <v-icon>{{ icon }}</v-icon>
  </span>
</template>

<script>
export default {
  name: "ehc-close-btn",
  props: {
    icon: {
      type: String,
      default: "mdi-close",
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
  transition: opacity 0.2s;
}

.pointer:hover {
  opacity: 0.7;
}
</style>
